import {Client} from '../../_models/Client'
import { toast } from 'react-toastify';

  export function updateClient(this:any, event:any) {
    event.preventDefault()
    let formData = new FormData();
    this.setState({updating: true})
    for (let key in this.state.client) {
      if (this.state.client[key] !== null) {
        let value = this.state.client[key]
        if(typeof(value) == 'object' && value.length > 0) {
          value = JSON.stringify(value)
        }
        formData.append(key, value);
      }
    }

    if (this.picture.files.length > 0) {
      formData.set("picture", this.picture.files[0]);
    }


    formData.append("accountType", window.account.type || "")
    formData.append("accountId", window.account.id || "")

    //return
    fetch('clients/edit', {
      method: 'POST',
      body: formData,
      headers: {
          "Content-Type": "multipart/form-data",
      },
    }).then(results => {
      return results.json();
    }).then(data => {
        let client = new Client(data.client)
        client.updated = true
        if(!this.state.client.id) {
          //New client, go back
          window.location.href="/clients"
        } else {
          //It's an update
          this.setState({client, updating: false})
        }
    }).catch(err => {
      alert(err.message);
      this.setState({updating: false})
    })


  }

  export function resetPassword(this:any, id: number, event:any) {
    event.preventDefault()
    let confirmed = confirm("האם אתה בטוח?")
    if(!confirmed) return
    fetch('clients/resetPassword', {
      method: 'POST',
      body: JSON.stringify({id})
    }).then(() => {
      toast.success("הסיסמה נשלחה ללקוח בהצלחה")
    }).catch(err => {
      alert(err.message);
    })
  }


  export function removeClient(this:any, id: number, index: number, event:any) {
    event.preventDefault()
    let confirmed = confirm("האם אתה בטוח?")
    if(!confirmed) return
    fetch('clients/delete', {
      method: 'POST',
      body: JSON.stringify({id})
    }).then(() => {
      let clients = this.state.clients
      clients.splice(index, 1)
      this.setState({clients})
    }).catch(err => {
      alert(err.message);
    })
  }


  export function handleSelectChange(this:any, selectedOption:any) {
    this.setState({ selectedOption }, () => {
      if(selectedOption.value) {
        let campaign = this.state.campaign
        campaign.updated = false
        this.setState({campaign})
      } else {
        let campaign = this.state.campaign
        campaign.updated = false
        this.setState({campaign})
      }
    });
  }




  export function handleClientChange(this:any, event: any) {
    let client = this.state.client
    client[event.target.name] = event.target.value
    client.updated = false
    this.setState({client});
  }



// WEBPACK FOOTER //
// ./src/pages/client/controller.tsx